import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAgents } from "../../api/communityApi";

const PERSONA_COLORS = {
  value: { from: "from-emerald-500/20", to: "to-emerald-500/5", text: "text-emerald-500", border: "border-emerald-500/30" },
  innovation: { from: "from-purple-500/20", to: "to-purple-500/5", text: "text-purple-500", border: "border-purple-500/30" },
  momentum: { from: "from-sky-500/20", to: "to-sky-500/5", text: "text-sky-500", border: "border-sky-500/30" },
  factor: { from: "from-amber-500/20", to: "to-amber-500/5", text: "text-amber-500", border: "border-amber-500/30" },
};

const AgentCard = ({ agent }) => {
  const colors = PERSONA_COLORS[agent.persona] ?? PERSONA_COLORS.factor;
  const positive = agent.total_return_pct >= 0;
  return (
    <Link
      to={`/community/profile/${agent.user_id}`}
      className={`group relative block rounded-2xl bg-gradient-to-br ${colors.from} ${colors.to} border ${colors.border} p-5 hover:-translate-y-1 transition-all overflow-hidden`}
    >
      <div className="flex items-start gap-3 mb-4">
        <img
          src={agent.avatar_url}
          alt={agent.display_name}
          className="w-12 h-12 rounded-xl flex-shrink-0"
        />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="font-bold text-base truncate">{agent.display_name}</h3>
            <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${colors.text} bg-black/10 dark:bg-white/10`}>
              BOT
            </span>
          </div>
          <p className={`text-xs ${colors.text} font-semibold`}>{agent.tagline}</p>
        </div>
      </div>

      <div className="flex items-baseline gap-3">
        <div>
          <p className="text-xs text-gray-500 dark:text-gray-400">Total Return</p>
          <p className={`text-2xl font-extrabold ${positive ? "text-emerald-500" : "text-red-500"}`}>
            {positive ? "+" : ""}{agent.total_return_pct?.toFixed(2)}%
          </p>
        </div>
        <div className="ml-auto text-right">
          <p className="text-xs text-gray-500 dark:text-gray-400">{agent.num_holdings} holdings</p>
          <p className="text-sm font-semibold">${agent.total_value?.toLocaleString()}</p>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-1.5">
        {(agent.top_holdings || []).slice(0, 4).map((h) => (
          <span
            key={h.symbol}
            className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-black/5 dark:bg-white/10 text-gray-700 dark:text-gray-300"
          >
            {h.symbol}
          </span>
        ))}
      </div>
    </Link>
  );
};

const AgentsRow = () => {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await getAgents();
        setAgents(Array.isArray(data?.agents) ? data.agents : []);
      } catch {
        setAgents([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading || agents.length === 0) return null;

  return (
    <div className="mb-10">
      <div className="flex items-baseline justify-between mb-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-emerald-500 mb-1">
            Featured strategies
          </p>
          <h2 className="text-2xl font-bold">Compete with the bots</h2>
        </div>
        <Link to="/community" className="text-sm text-indigo-500 hover:underline">
          View all →
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {agents.map((a) => (
          <AgentCard key={a.user_id} agent={a} />
        ))}
      </div>
    </div>
  );
};

export default AgentsRow;
